const ActionType = {
  AUTH_START: 'auth_start',
  AUTH_SUCCESS: 'auth_success',
  AUTH_ERROR: 'auth_error',
  CLEAR_ERROR: 'clear_error',
  CURRENT_USER_START: 'current_user_start',
  CURRENT_USER_SUCCESS: 'current_user_success',
  CURRENT_USER_ERROR: 'current_user_error',
  SIGNOUT_START: 'signout_start',
  SIGNOUT_SUCCESS: 'signout_success',
  SIGNOUT_ERROR: 'signout_error',
  STAFF_CHANGE_PASSWORD: 'staff_change_password',
  STAFF_CHANGE_PASSWORD_SUCCESS: 'staff_change_password_success',
  SET_HEADER: 'set_header',
  SET_SUB_HEADER: 'set_sub_header',
  SET_BACK_LINK: 'set_back_link',
  FETCH_DESIGNATION_START: 'fetch_designation_start',
  FETCH_DESIGNATION_SUCCESS: 'fetch_designation_success',
  FETCH_DESIGNATION_ERROR: 'fetch_designation_error',
  FETCH_STAFFS_START: 'fetch_staffs_start',
  FETCH_STAFFS_SUCCESS: 'fetch_staffs_success',
  FETCH_STAFFS_ERROR: 'fetch_staffs_error',
  FETCH_APPROVED_TRANSACTIONS_START: 'fetch_approved_transactions_start',
  FETCH_APPROVED_TRANSACTIONS_SUCCESS: 'fetch_approved_transactions_success',
  FETCH_APPROVED_TRANSACTIONS_ERROR: 'fetch_approved_transactions_error',
  FETCH_UNAPPROVED_TRANSACTIONS_START: 'fetch_unapproved_transactions_start',
  FETCH_UNAPPROVED_TRANSACTIONS_SUCCESS: 'fetch_unapproved_transactions_success',
  FETCH_UNAPPROVED_TRANSACTIONS_ERROR: 'fetch_unapproved_transactions_error',
  FETCH_CUSTOMERS_START: 'fetch_customers_start',
  FETCH_CUSTOMERS_SUCCESS: 'fetch_customers_success',
  FETCH_CUSTOMERS_ERROR: 'fetch_customers_error',
  FETCH_RETAILERS_START: 'fetch_retailers_start',
  FETCH_RETAILERS_SUCCESS: 'fetch_retailers_success',
  FETCH_RETAILERS_ERROR: 'fetch_retailers_error',
  FETCH_ENDUSERS_START: 'fetch_endusers_start',
  FETCH_ENDUSERS_SUCCESS: 'fetch_endusers_success',
  FETCH_ENDUSERS_ERROR: 'fetch_endusers_error',
  FETCH_CUSTOMER_SEARCH_START: 'fetch_customer_search_start',
  FETCH_CUSTOMER_SEARCH_SUCCESS: 'fetch_customer_search_success',
  FETCH_CUSTOMER_SEARCH_ERROR: 'fetch_customer_search_error',
  SET_CUSTOMER_VIEW: 'set_customer_view',
  STAFF_SEARCH_START: 'staff_search_start',
  STAFF_SEARCH_SUCCESS: 'staff_search_success',
  STAFF_SEARCH_ERROR: 'staff_search_error',
  SET_STAFF_VIEW: 'set_staff_view',
  FETCH_DASHBOARD_START: 'fetch_dashboard_start',
  FETCH_DASHBOARD_SUCCESS: 'fetch_dashboard_success',
  FETCH_DASHBOARD_ERROR: 'fetch_dashboard_error',
  APPROVED_TRANSACTIONS_SEARCH_START: 'approved_transactions_search_start',
  APPROVED_TRANSACTIONS_SEARCH_SUCCESS: 'approved_transactions_search_success',
  APPROVED_TRANSACTIONS_SEARCH_ERROR: 'approved_transactions_search_error',
  SET_APPROVED_TRANSACTIONS_VIEW: 'set_approved_transactions_view',
  UNAPPROVED_TRANSACTIONS_SEARCH_START: 'unapproved_transactions_search_start',
  UNAPPROVED_TRANSACTIONS_SEARCH_SUCCESS: 'unapproved_transactions_search_success',
  UNAPPROVED_TRANSACTIONS_SEARCH_ERROR: 'unapproved_transactions_search_error',
  SET_UNAPPROVED_TRANSACTIONS_VIEW: 'set_unapproved_transactions_view',
  FILTER_APPROVED_TRANSACTIONS_START: 'filter_approved_transactions_start',
  FILTER_APPROVED_TRANSACTIONS_SUCCESS: 'filter_approved_transactions_success',
  FILTER_APPROVED_TRANSACTIONS_ERROR: 'filter_approved_transactions_error',
  FILTER_UNAPPROVED_TRANSACTIONS_START: 'filter_unapproved_transactions_start',
  FILTER_UNAPPROVED_TRANSACTIONS_SUCCESS: 'filter_unapproved_transactions_success',
  FILTER_UNAPPROVED_TRANSACTIONS_ERROR: 'filter_unapproved_transactions_error'
};

export default ActionType;
